// Using window.history.replaceState directly instead of useRouter to avoid triggering a
// server component re-render — router.replace() in the App Router causes a full server round-trip.
// decodeURIComponent keeps [] instead of escaping them.
const replaceSearchParams = (pathname: string, params: URLSearchParams) => {
  const query = params.toString();
  window.history.replaceState(null, '', query ? `${pathname}?${decodeURIComponent(query)}` : pathname);
};

export default replaceSearchParams;
